import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, CalendarDays, ArrowRight, Newspaper } from "lucide-react";
import { api, resolveImg } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const fmtDate = (s) => {
  if (!s) return "";
  const d = new Date(s);
  return isNaN(d) ? "" : d.toLocaleDateString("ro-RO", { day: "2-digit", month: "long", year: "numeric" });
};

export default function ArticlesList() {
  const [articles, setArticles] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    document.title = "Articole & Sfaturi Auto | SIMSERV Slobozia";
    api.get("/content").then((r) => setCompany(r.data.settings?.company || {})).catch(() => setCompany({}));
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => setArticles([]));
  }, []);

  if (company === null || articles === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );

  return (
    <div className="min-h-screen bg-[#F4F6F9]" data-testid="articles-list-page">
      <Navbar company={company} />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <header className="mb-10 max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-wider text-[#FF5A1F] mb-2">Blog SIMSERV</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#0F1E36]">
            Articole &amp; Sfaturi Auto
          </h1>
          <p className="text-base text-slate-500 mt-4">
            Ghiduri practice despre ITP, mentenanță, distribuție, anvelope și tot ce
            trebuie să știi ca să-ți ții mașina în siguranță.
          </p>
        </header>

        {articles.length === 0 ? (
          <div className="text-center py-20 text-slate-400">
            <Newspaper className="w-12 h-12 mx-auto mb-4 opacity-40" />
            Momentan nu există articole publicate.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((a) => (
              <Link
                key={a.id}
                to={`/articole/${a.slug}`}
                data-testid={`article-card-${a.slug}`}
                className="group bg-white rounded-2xl border border-[#E2E8F0] overflow-hidden flex flex-col hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
              >
                <div className="aspect-[16/10] bg-[#F4F6F9] overflow-hidden">
                  {a.cover_image ? (
                    <img
                      src={resolveImg(a.cover_image)}
                      alt={a.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <Newspaper className="w-10 h-10 text-slate-300" />
                    </div>
                  )}
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-1.5 text-xs text-slate-400 mb-2">
                    <CalendarDays className="w-3.5 h-3.5" />
                    {fmtDate(a.created_at)}
                  </div>
                  <h2 className="font-display text-lg font-bold text-[#0F1E36] leading-snug group-hover:text-[#FF5A1F] transition-colors duration-200">
                    {a.title}
                  </h2>
                  <p className="text-sm text-slate-500 mt-2 line-clamp-3 flex-1">{a.excerpt}</p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF5A1F] mt-4">
                    Citește articolul <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
      <Footer company={company} />
    </div>
  );
}
